@if (settingsForm()) {
  <form [formGroup]="settingsForm()" class="settings-form__container">
    <mat-card class="settings-form__card">
      <mat-card-title>
        <div class="title">
          <span class="fs__md fw__500">Settings</span>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="settings-form__content">
          <div class="settings-form__row separator">
            <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" formControlName="useTitleInd">
              <div class="settings-form__row-title">
                <span class="fs__md fw__500">Show survey title</span>
                <span class="fs__sm caption">The title of the survey will be shown on the welcome screen</span>
              </div>
            </mat-slide-toggle>
          </div>
          <div class="settings-form__row separator">
            <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" formControlName="showLogoInd">
              <div class="settings-form__row-title">
                <span class="fs__md fw__500">Show Logo</span>
                <span class="fs__sm caption">The logos configured below will be visible on the survey</span>
              </div>
            </mat-slide-toggle>
          </div>
          @if (settingsForm().get('showLogoInd').value) {
            <div class="settings-form__columns separator">
              <div class="settings-form__row">
                <div class="settings-form__row-title">
                  <h2 class="fs__md fw__500">Main Logo</h2>
                  <span class="fs__sm caption">Create a branded survey with your own logo (size 180x32)</span>
                </div>
                <mat-slide-toggle
                  [labelPosition]="'before'"
                  [color]="'primary'"
                  [checked]="usingDefaultLogo$()"
                  [disabled]="!defaultLogo$()?.mediaId"
                  (change)="onSetDefaultLogo($event)"
                >
                  <div class="settings-form__row-title">
                    <span class="fs__md fw__500">Use default logo</span>
                    <span class="fs__sm caption"></span>
                  </div>
                </mat-slide-toggle>
                @if (hasMedia$()) {
                  @if (logo$().url$ | async; as url) {
                    <div class="settings-form__row-media">
                      <button mat-icon-button title="Delete" class="logo-delete__btn" color="warn" (click)="onDeleteLogo()">
                        <fa-icon [icon]="faTrashCan"></fa-icon>
                      </button>

                      <empathy-media-view [media]="logo$()" [url]="url"></empathy-media-view>
                    </div>
                  }
                } @else {
                  <eiq-file-uploader [uploading]="uploading$()" (uploaded)="onUploadLogo($event)"></eiq-file-uploader>
                }
              </div>

              @if (settingsForm().get('useTitleInd').value) {
                <div class="settings-form__row">
                  <div class="settings-form__row-title">
                    <h2 class="fs__md fw__500">Small Logo</h2>
                    <span class="fs__sm caption">Place a small logo (size 32x32) next to the title of the survey</span>
                  </div>
                  <mat-slide-toggle
                    [labelPosition]="'before'"
                    [color]="'primary'"
                    [checked]="usingDefaultIconLogo$()"
                    [disabled]="!defaultIconLogo$()?.mediaId"
                    (change)="onSetDefaultIconLogo($event)"
                  >
                    <div class="settings-form__row-title">
                      <span class="fs__md fw__500">Use default icon logo</span>
                      <span class="fs__sm caption"></span>
                    </div>
                  </mat-slide-toggle>
                  @if (hasIconMedia$()) {
                    @if (iconLogo$().url$ | async; as url) {
                      <div class="settings-form__row-media">
                        <button mat-icon-button title="Delete" class="logo-delete__btn" color="warn" (click)="onDeleteIconLogo()">
                          <fa-icon [icon]="faTrashCan"></fa-icon>
                        </button>

                        <empathy-media-view [media]="iconLogo$()" [url]="url"></empathy-media-view>
                      </div>
                    }
                  } @else {
                    <eiq-file-uploader [uploading]="uploadingIcon$()" (uploaded)="onUploadIconLogo($event)"></eiq-file-uploader>
                  }
                </div>
              }
            </div>
          }

          <div class="settings-form__row separator">
            <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" formControlName="isBackButtonDisabled">
              <div class="settings-form__row-title">
                <span class="fs__md fw__500">Disable Back button</span>
                <span class="fs__sm caption">
                  Prevent responders from going back to previously answered questions. This ensures linear progression through the survey.
                </span>
              </div>
            </mat-slide-toggle>
          </div>

          <div class="settings-form__row separator">
            <mat-slide-toggle [labelPosition]="'before'" [color]="'primary'" formControlName="useFeedbackInd">
              <div class="settings-form__row-title">
                <span class="fs__md fw__500">Show feedback question</span>
                <span class="fs__sm caption">The user will be asked for feedback at the end of the survey</span>
              </div>
            </mat-slide-toggle>
          </div>

          <empathy-terms-form
            [monitorProblematicIndCtrl]="settingsForm().get('monitorTerms').get('monitorProblematicInd') | toFormControl"
            [flagCurseWordsIndCtrl]="settingsForm().get('monitorTerms').get('flagCurseWordsInd') | toFormControl"
            [flagGibberishIndCtrl]="settingsForm().get('monitorTerms').get('flagGibberishInd') | toFormControl"
            [blockedTermsCtrl]="settingsForm().get('monitorTerms').get('blockedTerms') | toFormArray"
            [flaggedTermsCtrl]="settingsForm().get('monitorTerms').get('flaggedTerms') | toFormArray"
            [customErrorMessageIndCtrl]="settingsForm().get('monitorTerms').get('customErrorMessageInd') | toFormControl"
            [customErrorMessageCtrl]="settingsForm().get('monitorTerms').get('customErrorMessage') | toFormControl"
            [questionLevel]="false"
            (csvBlocksImport)="onCsvBlocksImport($event)"
            (csvFlagsImport)="onCsvFlagsImport($event)"
          ></empathy-terms-form>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
}
